import React, { useState, useEffect } from "react";
import { Route, Switch, Redirect, withRouter } from "react-router-dom";
import HomePage from "./HomePage";
import DietGenerator from "./DietGenerator";
import Diets from "./Diets";
import Header from "./common/Header";
import FoodDB from "./FoodDB";
import MealRecipes from "./MealRecipes";
import NotFoundPage from "./NotFoundPage";
import FoodPage from "./FoodPage";
import RecipePage from "./RecipePage";
import ProfilePage from "./ProfilePage";
import LoginPage from "./LoginPage";
import RegistrationPage from "./RegistrationPage";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import ProgressionPage from "./ProgressionPage";
import { getUserData } from "../api/authentication";

function App(props) {
    const [user, setUser] = useState();
    getSavedUser(); //TO DO: change to use redux
    //function getPage() {
    //  const route = window.location.pathname;
    //  //alert(route);
    //  if (route === "/Generator") return <DietGenerator />;
    //  else if (route === "/FoodDB") return <FoodDB />;
    //  else if (route === "/Recipes") return <MealRecipes />;
    //  else return <HomePage />;
    //}
    async function getSavedUser() {
        if (!user) {
            const savedUser = localStorage.getItem("user");
            if (savedUser) {
                let userData = JSON.parse(savedUser)
                setUser(userData);// save local storage user to avoid redirect to login
                userData = await getUserData(userData.id);
                setUser(userData);// save updated info of user after received from api call
            }
        }
        if (user && !user.hasProfile && props.location.pathname !== '/Profile') {
            props.history.push("/Profile");
        }
    }

    //useEffect(() => {
        //getSavedUser();
    //}, []);

    function handleUserLogged(loggedUser) {
        setUser(loggedUser);
        localStorage.setItem("user", JSON.stringify(loggedUser));
        if (loggedUser.hasProfile)
            props.history.push("/Generator");
        else
            props.history.push("/Profile");
    }

    function handleLogout() {
        setUser(null);
        localStorage.clear();
    }

    return (
        <div className="container">
            <ToastContainer autoClose={3000} />
            <Header user={user} onLogOut={handleLogout} />
            <Switch>
                <Route path="/" exact component={HomePage} />
                <Route path="/Login">
                    <LoginPage onAuth={handleUserLogged} />
                </Route>
                <Route path="/Register">
                    <RegistrationPage onRegistration={handleUserLogged} />
                </Route>
                {user ? (
                    <Switch>
                        <Route path="/Profile">
                            <ProfilePage user={user} />
                        </Route>
                        <Route path="/Diets" render={props => <Diets {...props} user={user} />} />
                        <Route path="/Generator/:dietId" render={props => <DietGenerator {...props} user={user} />} /> {/*using render helps to send the props to the DietGenerator component, otherwise couldnt get the dietId match param*/}
                        <Route path="/Generator" render={props => <DietGenerator {...props} user={user} />} />
                        <Route path="/Progression">
                            <ProgressionPage user={user} />
                        </Route>
                        <Route path="/FoodDB" component={FoodDB} />
                        <Route path="/Food/:foodId" render={props => <FoodPage {...props} user={user} />} />
                        <Route path="/Food" render={props => <FoodPage {...props} user={user} />} />
                        <Route path="/Recipes" component={MealRecipes} />
                        <Route path="/Recipe/:recipeId" component={RecipePage} />
                        <Route path="/Recipe" component={RecipePage} />
                        <Route component={NotFoundPage} />
                    </Switch>
                ) : (
                    <Redirect to="/Login" />
                )}
            </Switch>
            {/*getPage()*/}
        </div>
    );
}

export default withRouter(App); //withRouter is necessary to allow access to props.history in handleUserLogged
